import script from "./Categorias.vue?vue&type=script&setup=true&lang=js"
export * from "./Categorias.vue?vue&type=script&setup=true&lang=js"

import "./Categorias.vue?vue&type=style&index=0&id=6e6bf15a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e6bf15a"]])

export default __exports__